export default __webpack_public_path__ + "static/media/user_jeff.91f92135.png";